import { CART_ITEM_SOURCE_TYPES } from 'vivino-js/context/CartItemSourceContext';
import { getCartItemSource } from 'vivino-js/helpers/cartItemSources';
import t from 'vivino-js/translationString';
import { wineryUrl } from 'vivino-js/vivinoUrls';
import { Winery } from 'vivino-ui/icons/WineFacts';

const TRANSLATION_PATH = 'components.shared.wine_summary';
const TRANSLATIONS = {
  winery: `${TRANSLATION_PATH}.winery`,
};

export const getWineryFact = (vintage, translationFunc = t) => {
  const winery = vintage?.wine?.winery;
  const cartItemSourceData = getCartItemSource(
    CART_ITEM_SOURCE_TYPES.WINERY_PAGE_WINE_PAGE_WINE_FACTS
  );

  if (!winery) {
    return null;
  }
  return {
    key: 'winery',
    headerLabel: translationFunc(TRANSLATIONS.winery),
    icon: Winery,
    values: [
      {
        name: winery.name,
        url: `${wineryUrl({ winery })}`,
        cartItemSource: cartItemSourceData,
      },
    ],
  };
};
